import axios from 'axios';
import { VuexModule, Module, Action, Mutation} from 'vuex-module-decorators';
import { RegistrationForm, LoginedUser } from './AuthModel';




@Module({ namespaced: true })
class Register extends VuexModule {
    public user = localStorage.getItem('userData') as LoginedUser | null;

    @Mutation
    public REGISTER(data: LoginedUser) {
        this.user = data;
        localStorage.setItem('userData', JSON.stringify(data))
     }   


    @Action({ rawError: true })
    public async register(registerationData: RegistrationForm) {

        const promise = new Promise((resolve, reject) => {
       
            axios
                .post("api/register", registerationData)
                .then(({ data }) => {
                    this.context.commit('REGISTER', data)
                    resolve(data)
                })
                .catch(error => {
                    reject(error)
                });
        
        })

        return promise;
    }

    get registeredUser() {
    
        if (this.user?.email == undefined) {
            const toUnknown = this.user as unknown
            const userJson = toUnknown as string
            const user = JSON.parse(userJson);
            return user
        }

        return this.user; 
    }

    get fullName() {
        return `${this.registeredUser.first_name} ${this.registeredUser.last_name}`;
    }

    
}

export default Register;